import { render } from "./orders_finalize.vue?vue&type=template&id=e95149ba"
import script from "./orders_finalize.vue?vue&type=script&lang=js"
export * from "./orders_finalize.vue?vue&type=script&lang=js"

import "./orders_finalize.vue?vue&type=style&index=0&id=e95149ba&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__